import { Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

export const InstagramFooter: React.FC = () => {
  return (
    <Container sx={{ py: 3 }}>
      <Helmet>
        <script src="https://cdn.lightwidget.com/widgets/lightwidget.js" />
      </Helmet>
      <Typography
        variant="h3"
        gutterBottom
        sx={{
          textAlign: 'center',
          textTransform: 'uppercase'
        }}
      >
        Follow us on Instagram
      </Typography>
      <iframe
        src="//lightwidget.com/widgets/1d54a9bf7b0d53268d661e58486af804.html"
        title="FOLLOW US ON INSTAGRAM"
        scrolling="no"
        className="lightwidget-widget"
        style={{
          border: 0,
          width: '100%',
          overflow: 'hidden',
          backgroundColor: 'transparent'
        }}
      />
    </Container>
  );
};
